import script from "./overview-navigation-checklists.vue?vue&type=script&setup=true&lang=ts"
export * from "./overview-navigation-checklists.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__